import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionTablesDisplayGridRowDataFragmentGql } from './VirtualConnectionTablesDisplayGridRowDataFragmentGql';

export const TableDownstreamVirtualConnectionTablesFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamVirtualConnectionTablesFilteredByColumnQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionTableSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      downstreamVirtualConnectionTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...VirtualConnectionTablesDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${VirtualConnectionTablesDisplayGridRowDataFragmentGql}
`;
